/** Backend col_type values for spreadsheet columns; labels for display. */
export const SPREADSHEET_COLUMN_TYPES = [
  'str',
  'url',
  'num',
  'bool',
  'date',
  'list'
] as const;

export type SpreadsheetColumnType = (typeof SPREADSHEET_COLUMN_TYPES)[number];

export const SPREADSHEET_COLUMN_TYPE_LABELS: Record<
  SpreadsheetColumnType,
  string
> = {
  str: 'Text',
  url: 'URL',
  num: 'Number',
  bool: 'Boolean',
  date: 'Date',
  list: 'List'
};

export type SpreadsheetColumnTypeMap = Record<string, SpreadsheetColumnType>;
